import { render, staticRenderFns } from "./ReturnExchangeDeliveryAmount.vue?vue&type=template&id=69015b46&"
import script from "./ReturnExchangeDeliveryAmount.vue?vue&type=script&lang=ts&"
export * from "./ReturnExchangeDeliveryAmount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports